import {Divider, Image, Layout, Typography} from 'antd';
import React from 'react';
import appColors from '../../../style/theme';

const {Text, Paragraph} = Typography;
const Content = Layout;

const DosM = () => {
  return (
    <Layout style={{margin: '0 5.2vh 5.2vh 5.2vh', background: 'transparent'}}>
      <Content style={{background: 'inherit'}}>
        <Paragraph className= 'Title3T' style={{color: appColors['ColorX'], marginTop: '3%'}}>Target and Potential Market</Paragraph>
        <Text className='BaseText2'>In the beginning, we would not like to define our target market too broadly. As inflammaging involves a wide variety of chronic diseases, frailty and mortality <b>we decided not to segment more this market.</b> Also, as we are promoting healthy aging <b>we believe that younger people will be interested in buying this diagnostic tool.</b> We validate our potential market in the section of Human Practices.<br/><br/>To know more about each segment click in the sections below:</Text>
        <Content style={{marginLeft: 'auto', marginRight: 'auto', maxWidth: '80%', background: 'inherit', marginTop: '2%'}}>
          <Image src='https://static.igem.wiki/teams/4464/wiki/emprendimiento/imagen-market-target.png'/>
          <p> <b>Fig. 2.</b> Target and Potential Market of ImoAge [6-9]</p>
        </Content>
      </Content>
      <Divider/>
    </Layout>
  );
};

export default DosM;
